export enum ControlType {
    TEXTFIELD = 1,
    CHECKBOX = 2,
    DROPLIST = 3,
    RADIOBUTTON = 4,
    NUMBER = 5,
    AGE = 6,
    PLACEHOLDER = 7,
    EMAIL = 8,
    OCCUPATION = 9,
    CURRENCY = 10,
    OPENENDEDTEXT = 11,
    DATE_DROPDOWN = 12,
    DATE_PICKER = 13,
    OPENTEXT_EXTRA = 14,
    BANK_ACCOUNT = 15,
    ADDRESSFIELD = 16,
    EMAIL_ADDRESS = 17,
    PHONE_NUMBER = 18,
    SINGLE_TEXT = 19
}
